import React from "react";
import { useTranslation } from "react-i18next";
import { Input, Row, Col } from "reactstrap"; // Added Spinner


const CrawlFrom = ({ labels, formikProps, isAddOrEdit }) => {
    const { t, i18n } = useTranslation();

  // Destructure from formikProps for easier access
  const { values, errors, touched, handleChange, handleBlur } = formikProps;
    
  const renderField = (item) => {
    const fieldValue = values[item.name] ?? "";

    switch (item.fieldName) {
      case "text-box":
        return (
          <Input
            type={"text"}
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange}
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      case "number":
        return (
          <Input
            type="tel"
            id={item.name}
            name={item.name}
            placeholder={t(item.placeholder || item.labelName)}
            value={fieldValue}
            onChange={handleChange} 
            onBlur={handleBlur}
            className="form-control"
            invalid={touched[item.name] && !!errors[item.name]}
            required={item.required}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Row>
      {labels.map((item) => {
        
        return (
          <Col sm={6} key={item.name}>
            <div className="mb-3">
              {item.labelName !== "Mobile" && (
                <label htmlFor={item.name} className="col-form-label">
                  {t(item.labelName)}
                  {item.required && <span className="text-danger"> *</span>}
                </label>
              )} 
              {/* Render the field */}
              {renderField(item)}
              {/* Display error for the main field */}
              {item.labelName !== "Mobile" && touched[item.name] && errors[item.name] &&(
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )}
              {item.fieldName === "icon" && touched[item.name] && errors[item.name] && (
                <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>{t(errors[item.name])}</div>
              )}
            </div>
          </Col>
        );
      })}
    </Row>
  );
}

export default CrawlFrom